import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchScheduleNotesHistoryArgs,
  FetchOrgScheduleNotesArgs,
  FetchScheduleNotesArgs,
} from '../api/types/scheduleNote.types';

import {
  fetchScheduleNotesHistory,
  fetchOrgScheduleNotes,
  fetchScheduleNotes,
} from '../api/scheduleNote.api';

export const scheduleNoteQueryKeys = createQueryKeys('scheduleNote', {
  fetchOrgScheduleNotes: ({
    from,
    organizationId,
    to,
  }: FetchOrgScheduleNotesArgs) => ({
    queryFn: () => fetchOrgScheduleNotes({ from, organizationId, to }),
    queryKey: [organizationId, from, to],
  }),
  fetchScheduleNotes: ({
    clientId,
    from,
    organizationId,
    to,
  }: FetchScheduleNotesArgs) => ({
    queryFn: () => fetchScheduleNotes({ clientId, from, organizationId, to }),
    queryKey: [organizationId, clientId, from, to],
  }),
  fetchScheduleNotesHistory: ({
    clientId,
    organizationId,
  }: Pick<FetchScheduleNotesHistoryArgs, 'clientId' | 'organizationId'>) => ({
    queryFn: () =>
      fetchScheduleNotesHistory({ clientId, organizationId, page: 1 }),
    queryKey: [organizationId, clientId],
  }),
});
